import React, {useCallback, useState} from 'react';
import MarketplaceButton from "../../../common/MarketplaceButton";
import './style.scss'
import ModalLayout from "../../../common/Modals";
import {formatterUS} from "../../../../utils";

const LockVeTRESRModal = ({
                               isOpen,
                               balance,
                               alreadyLocked,
                               onClose,
                               onStake,
                               onStakeClose,
                               title,
                               description,
                               placeholder,
                               marginTop = 0
                           }) => {

  const [stake, setStake] = useState(0);
  const onChangeStake = useCallback((event) => {
    if (isNaN(event?.target?.value)) {
      return
    }

    const amount = Number(event?.target?.value);
    const max = 50_000_000 - alreadyLocked
    setStake(Math.min(amount, max))
  }, [alreadyLocked])

  const onClickMax = useCallback(() => {
    const max = 50_000_000 - alreadyLocked;
    setStake(Math.min(max, balance))
  }, [balance, alreadyLocked])


  return (
    <ModalLayout
      padding={'40px'}
      onClose={onClose}
      isOpen={isOpen}
      maxWidth={'458px'}
      maxHeight={'392px'}
      withCrossIcon
    >
      <h2 className="modal__title onStakeTRESRModal__title">{title}</h2>
      <p className='modal__text'>{description}</p>
      <p className='onStakeTRESRModal__text'>Available veTRESR to lock: {formatterUS(balance)}</p>
      <p className='onStakeTRESRModal__text'>$TRESR to be burned: {formatterUS(stake/100)}</p>
      <div className='onStakeTRESRModal__inputContainer' style={{
        marginTop: '20px'
      }}>
        <input
          className='modal__input onStakeTRESRModal__input'
          type="number"
          placeholder={placeholder}
          value={stake !== 0 ? stake : ''}
          onChange={onChangeStake}
        />
        <p className='onStakeTRESRModal__input--max' onClick={onClickMax}>max</p>
      </div>
      <div className='modal__actionButtons flex-grow justify-end items-end' style={{marginTop: `${marginTop}px`}}>
        <MarketplaceButton title={'Cancel'} onClick={onStakeClose}/>
        <MarketplaceButton title={'Continue'} onClick={() => onStake(stake)} isBlue disabled={+stake > +balance}/>
      </div>
    </ModalLayout>
  );
};

export default LockVeTRESRModal;
